import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {Favorite, FavoriteList} from '@models/favorite';
import {AdService} from '@services/ad.service';
import {EMPTY_FAVORITE_LIST, EMPTY_USER, EVOL_DEMO_LAST_YEAR} from '@models/empty';
import * as _ from 'underscore';
import {ConfirmComponent} from '@components/popup/confirm/confirm.component';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {CommonService} from '@services/common.service';
import {LabelType, Options} from '@angular-slider/ngx-slider';
import {City} from '@models/city';
import {User} from '@models/user';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {CityService} from '@services/city.service';
import {OnboardingService} from '@services/onboarding.service';
import {SharePopupComponent} from '@module/favorites/list/share-popup/share-popup.component';
import {RenamePopupComponent} from '@module/favorites/list/rename-popup/rename-popup.component';
import {AddComponent} from '@module/favorites/popup/add/add.component';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {Title} from '@angular/platform-browser';
import {AlertService} from '@services/alert.service';
import {NewPopupComponent} from '@module/favorites/list/new-popup/new-popup.component';
import {UserService} from '@services/user.service';
import {LoginFormComponent} from '@components/popup/login-form/login-form.component';
import {NotesComponent} from '@module/favorites/popup/notes/notes.component';
import {OrderListPopupComponent} from '@module/favorites/list/order-list-popup/order-list-popup.component';

@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

    listFavorite: FavoriteList[] = [];
    favoritesList: FavoriteList = EMPTY_FAVORITE_LIST;
    favoritesBase: Favorite[] = [];
    favorites: Favorite[] = [];

    loading = true;
    columsSelection = false;
    search = false;
    currentList;

    user: User = Object.assign({}, EMPTY_USER);
    displayedColumns: string[] = [];
    sort = 'add-desc';
    cities: City[] = [];
    status: string[] = [];

    sub_fav = null;

    searchForm = new UntypedFormGroup({
        title: new UntypedFormControl(''),
        price: new UntypedFormControl(null),
        rendement: new UntypedFormControl(null),
        ville: new UntypedFormControl(null),
        status: new UntypedFormControl(null),
    });

    options: Options = {
        floor: 0,
        ceil: 10,
        translate: (value: number, label: LabelType): string => {
            return value + ' €';
        }
    };

    optionsRendement: Options = {
        floor: 0,
        ceil: 30,
        translate: (value: number, label: LabelType): string => {
            return value + ' %';
        }
    };

    constructor(
        public dialog: MatDialog,
        private router: Router,
        private route: ActivatedRoute,
        private titleService: Title,
        private alertService: AlertService,
        private userService: UserService,
        public adService: AdService,
        public onboardingService: OnboardingService,
        public authenticationService: AuthenticationService,
        public commonService: CommonService,
        public trackingService: TrackingService,
        public cityService: CityService,
    ) {
    }

    ngOnInit() {
        this.user = this.authenticationService.currentUser;
        if (this.authenticationService.currentUser.user_dashboard.favorite_kpi === undefined || this.authenticationService.currentUser.user_dashboard.favorite_kpi  === null || this.authenticationService.currentUser.user_dashboard.favorite_kpi.length == 0 || !this.authenticationService.isAllowed('expert')) {
            this.displayedColumns = ['ad_city.price_diff', 'ad_city.demographie_annuelle', 'ad_city.carac_commune.mv', 'favorite.ad_city.renta', 'ad_city.carac_commune.te', 'ad_city.advice_price', 'amount_rent', 'ad_city.carac_commune.tc'];
        } else {
            this.displayedColumns = this.authenticationService.currentUser.user_dashboard.favorite_kpi;
        }

        this.searchForm.valueChanges.subscribe(
            name => {
                // Filters
                var that = this;
                this.trackingService.click('favorite_list_search_process', this.currentList);
                this.favorites = this.favoritesBase.filter(function(data) {
                    const searchTerms = that.searchForm.getRawValue();
                    if (searchTerms.title !== ''
                        && (data.title.toLowerCase().indexOf(searchTerms.title.toLowerCase()) === -1)
                        && (data.ad_city.name.toLowerCase().indexOf(searchTerms.title.toLowerCase()) === -1)
                    ) {
                        return false;
                    }

                    if (searchTerms.ville && searchTerms.ville.length > 0 && !searchTerms.ville.includes(data.ad_city.city_code)) {
                        return false;
                    }

                    if (searchTerms.status && searchTerms.status.length > 0 && !searchTerms.status.includes(data.status)) {
                        return false;
                    }

                    if (searchTerms.price !== null && (data.price < searchTerms.price[0] || data.price > searchTerms.price[1])) {
                        return false;
                    }

                    if (searchTerms.rendement !== null && searchTerms.rendement[1] != 30 && (data.efficiency_brut < searchTerms.rendement[0] || data.efficiency_brut > searchTerms.rendement[1])) {
                        return false;
                    }

                    return true;
                });
                this.sortFav();
            }
        );

        this.route.params.subscribe(params => {
            this.loading = true;

            this.adService.getFavoritesLists().subscribe(result => {
                this.listFavorite = result;
            });
            this.currentList = params.id;

            if (this.sub_fav) {
                this.sub_fav.unsubscribe();
            }

            this.sub_fav = this.adService.getFavoritesList(params.id).subscribe(result => {
                const that = this;
                result.favorites.forEach((fav, i) => {
                    result.favorites[i] = that.adService.updateValues(fav);
                });
                this.favoritesList = result;
                this.favorites = result.favorites;
                this.favoritesBase = result.favorites;
                this.titleService.setTitle('LyBox - ' + "Mes favoris " + this.favoritesList.title);

                const existing = [];
                result.favorites.forEach(function(d) {
                    if (d.price > this.options.ceil) {
                        this.options.ceil = d.price;
                    }
                    if (!existing.includes(d.ad_city.city_code)) {
                        existing.push(d.ad_city.city_code);
                        this.cities.push(d.ad_city);
                    }
                    if (!this.status.includes(d.status)) {
                        this.status.push(d.status);
                    }
                }, this);
                this.searchForm.get('price').setValue([0, this.options.ceil]);
                this.loading = false;
                this.sortFav();

                if (result.favorites.length >= 1) {
                    if (this.authenticationService.currentUser.user_onboarding.auto && this.authenticationService.currentUser.user_onboarding.favoris_list.status == 'not_started') {
                        this.onboardingService.startFavoriteList(params.id).subscribe();
                    } else {
                        this.onboardingService.endFavoriteList();
                    }
                }
            }, error => {
                if (error != 'token_outdate') {
                    this.alertService.error('Liste introuvable', true);
                    this.router.navigate(['/app/favorites']);
                }
            });
        });
    }

    openRenameDialog(): void {
        if (this.favoritesList.user_id != this.user.id) {
            this.alertService.error('Seul le propriétaire de la liste peut effectuer cette action');
            return;
        }
        const dialogRef = this.dialog.open(RenamePopupComponent, {
            width: '420px',
            data: {favoritesList: this.favoritesList},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != undefined && result !== false) {
                this.alertService.success("Enregistrement réussi.");
                this.trackingService.click('favorite_list_rename_confirm', this.currentList);
                this.favoritesList.title = result.title;
                this.listFavorite.forEach((f, i) => {
                    if (f.id === result.id) {
                        this.listFavorite[i].title = result.title;
                    }
                });
            } else {
                this.trackingService.click('favorite_list_rename_cancel', this.currentList);
            }
        });
    }

    openNewDialog(): void {
        if (this.favoritesList.user_id != this.user.id) {
            this.alertService.error('Seul le propriétaire de la liste peut effectuer cette action');
            return;
        }
        const dialogRef = this.dialog.open(NewPopupComponent, {
            width: '420px',
            data: {favoritesList: this.favoritesList},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != undefined && result !== false) {
                this.alertService.success("Enregistrement réussi.");
                this.trackingService.click('favorite_list_new_confirm', this.currentList);
                this.router.navigate(['/app/favorites', result]);
            } else {
                this.trackingService.click('favorite_list_new_cancel', this.currentList);
            }
        });
    }

    openShareDialog(): void {
        if (this.favoritesList.user_id != this.user.id) {
            this.alertService.error('Seul le propriétaire de la liste peut effectuer cette action');
            return;
        }

        const dialogRef = this.dialog.open(SharePopupComponent, {
            width: '420px',
            data: {favoritesList: this.favoritesList},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== undefined && result !== false) {
                this.trackingService.click('favorite_list_share_confirm', this.currentList);
                this.alertService.success('Modification enregistrée.');
                this.listFavorite.forEach((f, i) => {
                    if (f.id === this.favoritesList.id) {
                        if (result.length == 0) {
                            this.listFavorite[i].share = false;
                        } else {
                            this.listFavorite[i].share = true;
                        }
                    }
                });
            } else {
                this.trackingService.click('favorite_list_share_cancel', this.currentList);
            }
        });
    }

    deleteFavoriteList(): void {
        if (this.favoritesList.user_id != this.user.id) {
            this.alertService.error('Seul le propriétaire de la liste peut effectuer cette action');
            return;
        }

        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '420px',
            data: {message: 'Etes-vous sûr de vouloir supprimer cette liste et perdre tous les favoris enregistrés ?'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.alertService.success("Supprésion réussi.");
                this.trackingService.click('favorite_list_delete_confirm', this.currentList);
                this.trackingService.deleteFavoriteList();
                this.adService.deleteFavoriteList(this.favoritesList.id).subscribe(r => {
                    this.router.navigate(['/app/favorites']);
                });
            } else {
                this.trackingService.click('favorite_list_delete_cancel', this.currentList);
            }
        });
    }

    displayColumsSelection() {
        this.columsSelection = !this.columsSelection;
    }

    displaySearchForm() {
        this.search = !this.search;
    }

    onColChange(val) {
        if (!this.authenticationService.isAllowed('expert')) {
            this.upgradePlan('assets/upgrade/indicateurs.png', 'Personnalisation des favoris', 'Expert');
        } else {
            this.trackingService.click('favorite_list_indicateur_change', this.currentList);
            if (_.difference(val, this.displayedColumns).length !== 0) {
                // Checked
                this.displayedColumns.push(_.difference(val, this.displayedColumns)[0]);
            } else if (_.difference(this.displayedColumns, val).length !== 0) {
                // Unchecked
                this.displayedColumns = _.without(this.displayedColumns, _.difference(this.displayedColumns, val)[0]);
            }
            this.user.user_dashboard.favorite_kpi = this.displayedColumns;
            this.userService.updateDashboard(this.user);
        }
    }

    upgradePlan(visuel = '', feature, plan) {
        this.trackingService.click('favorite_list_upgrade_plan', feature);
        if (!this.authenticationService.isLogin) {
            const dialogRef = this.dialog.open(LoginFormComponent, {
                width: '550px',
                data: {
                    disableClose: false
                },
            });
        } else {
            if (!this.authenticationService.isLogin) {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    data: {
                        disableClose: false
                    },
                });
            } else {
                const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                    width: '520px',
                    data: {visuel, plan, feature}
                });
            }
        }
    }

    changeList() {
        this.favorites = [];
        this.router.navigate(['/app/favorites', this.currentList]);
    }

    compareAdd(favorite) {
        if (!this.authenticationService.isAllowed('essentiel')) {
            this.upgradePlan('assets/upgrade/compare.png', 'Comparaison entre projets', 'Essentiel');
        } else {
            this.adService.getCompareAd().subscribe(ads => {
                if (ads.length >= 5) {
                    this.trackingService.click('favorite_list_compare_fail', this.currentList);
                    this.alertService.error('Comparaison limité à 5 projets, veuillez supprimer un projet dans la comparaison.');
                } else {
                    this.trackingService.click('favorite_list_compare_success', this.currentList);
                    this.adService.addCompareAd(favorite.id);
                    this.alertService.success('Projet ajouté.');
                }
            });
        }
    }

    deleteFavorite(favorite): void {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '420px',
            data: {message: 'Etes-vous sûr de vouloir supprimer votre favoris "' + favorite.title + '" et perdre toute les informations saisies ?'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.alertService.success("Suppréssion réussi.");
                this.trackingService.click('favorite_list_favorite_delete_confirm', this.currentList);
                this.trackingService.deleteFavorite();
                this.adService.deleteFavorite(favorite).subscribe(r => {
                    this.favorites.forEach((f, i) => {
                        if (f.id === favorite.id) {
                            this.favorites.splice(i, 1);
                        }
                    });

                    this.favoritesBase.forEach((f, i) => {
                        if (f.id === favorite.id) {
                            this.favoritesBase.splice(i, 1);
                        }
                    });
                });
            } else {
                this.trackingService.click('favorite_list_favorite_delete_cancel', this.currentList);
            }
        });
    }

    sortFav() {
        var that = this;
        this.favorites.sort(function(a, b) {
            if (that.sort == 'add-desc') {
                return (Date.parse(a.created_at) >= Date.parse(b.created_at) ? -1 : 1);
            } else if (that.sort == 'add-asc') {
                return (Date.parse(a.created_at) < Date.parse(b.created_at) ? -1 : 1);
            } else if (that.sort == 'first_publication-desc') {
                return (Date.parse(a.ad.fpb) >= Date.parse(b.ad.fpb) ? -1 : 1);
            } else if (that.sort == 'first_publication-asc') {
                return (Date.parse(a.ad.fpb) < Date.parse(b.ad.fpb) ? -1 : 1);
            } else if (that.sort == 'price-desc') {
                return (a.price >= b.price ? -1 : 1);
            } else if (that.sort == 'price-asc') {
                return (a.price < b.price ? -1 : 1);
            } else if (that.sort == 'rendement-desc') {
                return (a.efficiency_brut >= b.efficiency_brut ? -1 : 1);
            } else if (that.sort == 'rendement-asc') {
                return (a.efficiency_brut < b.efficiency_brut ? -1 : 1);
            }
            return 0;
        });
    }

    noteFavorite(favorite): void {
        const dialogRef = this.dialog.open(NotesComponent, {
            width: '420px',
            data: {favorite: favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                favorite.comment = result.comment
            }
        });
    }

    orderList(): void {
        console.log(this.listFavorite)
        const dialogRef = this.dialog.open(OrderListPopupComponent, {
            width: '420px',
            data: {listFavorite: this.listFavorite},
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    }

    moveFavorite(favorite): void {
        const dialogRef = this.dialog.open(AddComponent, {
            width: '420px',
            data: {favorite: favorite, mode: 'move'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.alertService.success("Modification réussi.");
                this.trackingService.click('favorite_list_favorite_move_confirm', this.currentList);
                this.favorites.forEach((f, i) => {
                    if (f.id === favorite.id) {
                        this.favorites.splice(i, 1);
                    }
                });

                this.favoritesBase.forEach((f, i) => {
                    if (f.id === favorite.id) {
                        this.favoritesBase.splice(i, 1);
                    }
                });
            } else {
                this.trackingService.click('favorite_list_favorite_move_cancel', this.currentList);
            }
        });
    }

    protected readonly EVOL_DEMO_LAST_YEAR = EVOL_DEMO_LAST_YEAR;
}
